import React from 'react';
import ReactDOM from 'react-dom';
import 'styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'styled-components';
import { theme } from 'themes/theme';
import { Normalize } from 'styled-normalize';
import { GlobalStyle } from 'styles/globalStyles';
import { FontStyles } from 'styles/fontStyles';
import { AppProvider } from 'utils/AppProvider';
import TagManager from 'react-gtm-module';
import './locales/index';


const tagManagerArgs = {
  gtmId: 'GTM-TDSDRR'
}

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <ThemeProvider theme={theme}>
        <Normalize />
        <FontStyles />
        <GlobalStyle />
        <App />
      </ThemeProvider>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
